var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalCareCuate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-115"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 64.1,
    width: 175.46,
    height: 399.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.03 463.83 48.57 463.83 48.57 54.63 58.03 64.1 58.03 463.83",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 87.75,
    width: 129.57,
    height: 185.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.19,348.9c.6,22.2.86,47.1.92,69.3,0,7.7.1,15.4.06,23.11l-1-1,20.84.09c20,.08,42.51.36,62.54.9-20,.53-42.5.81-62.54.89l-20.84.09h-1c0-8,0-16.06.06-24.09.06-22.2.32-47.1.92-69.3Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.34,397.88c-.57-25.57-.85-54.25-.91-79.83l-.08-26.61,1,1-25.9-.09c-24.91-.07-52.82-.34-77.72-.91,33.47-.78,70.08-.9,103.62-1h1v1c-.09,34.47-.2,72.05-1,106.44Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.5 64.1 58.03 64.1 48.57 54.63 233.5 54.63 233.5 64.1",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.98,
    y: 287.03,
    width: 22.18,
    height: 41.73,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.88 296.18 97.88 305.64 80.98 304.28 80.98 296.18 97.88 296.18",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.48,
    y: 291.44,
    width: 29.4,
    height: 9.46,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.52,
    y: 60.02,
    width: 93.99,
    height: 117.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.9,
    y: 63.01,
    width: 87.24,
    height: 111.17,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 74.77,
    width: 63.03,
    height: 87.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.51,
    y: 60.02,
    width: 2.17,
    height: 117.15,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.57,463.83c129.05-.61,273.81-.62,402.86,0-129,.62-273.81.61-402.86,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.35,463c2.46.82,72.81.62,75.49-1.08,1-.64,1.59-10.9,1.92-23.3.08-2.68.13-5.43.17-8.25.06-3.33.1-6.7.12-10,.09-14.69-.12-27.63-.12-27.63h-45.8l0,27.63v10l.24,8.25S314.5,450.79,311.77,453,306.89,462.23,309.35,463Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.35,463c2.46.82,72.81.61,75.49-1.08,1-.6,1.51-9.53,1.84-20.77-5.63,2.61-54.29,12.6-65.75,12.73-11,.11,6.51-8.76,9.3-10.14-7.74,3.6-16.92,8-18.46,9.2C309,455.15,306.9,462.23,309.35,463Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.67,191.72S387.66,303.3,386,312.2c-.39,2,4.64,119,4.64,119H338.09s0-103.3,2.12-121.08,29.34-118.37,29.34-118.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.67,191.73S400,241.41,392.34,279.92l-22.8-88.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.19,420.57c-2.88-.37-24.85-1.13-43.23-.34-.12,0-.11.17,0,.18,6,.54,39.83.76,43.2.38C385.28,420.78,385.32,420.59,385.19,420.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.8,463.53c2.47.8,72.82-.08,75.48-1.81,1-.65,1.48-10.91,1.7-23.31,0-2.68-1.75-45.61-1.75-45.61l-44.32.2.71,45.85s-26.78,12.39-29.5,14.6S367.34,462.75,369.8,463.53Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.8,463.54c2.47.79,72.83-.09,75.49-1.82.89-.58,1.35-8.75,1.6-19.25-10.19,3.06-53.67,10.93-64.39,10.83-9.74-.1,3-6.76,8-9.22-7.71,3.66-16.84,8.12-18.37,9.37C369.42,455.64,367.33,462.75,369.8,463.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,432.12h53.48s-10.13-79-10.93-92.29c-.41-6.77-4.73-76.22-8.65-108.79,0,0,0-6.15-.28-15.31-.23-8-6.21-24-6.21-24H369.5s.89,19.23,7.3,35.3a98,98,0,0,1,14.55,6.48s2.81,96.35,3.71,113.6C396.19,369,398,432.12,398,432.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.64,218.79c-.17-1.16-.35-2.32-.52-3.47-.33-2.12-.76-4.23-1.13-6.34-.85-4.79-1.72-9.6-2.79-14.34,0-.12-.22-.09-.2,0,.18,1.92.4,3.83.68,5.74s.46,3.83.72,5.74c.54,3.78,1.07,7.57,1.71,11.34.25,1.45,1.15,4-.94,4.5-1.65.36-2.86-1.27-3.35-2.63a33.09,33.09,0,0,1-1.11-5.23q-.51-2.87-.91-5.74c-.59-4.19-1.24-8.36-1.92-12.53,0-.12-.21-.08-.21,0a127.62,127.62,0,0,0,.92,12.82q.41,3.06.92,6.1a22,22,0,0,0,1.4,5.67,4.64,4.64,0,0,0,3.46,2.78h.1a.14.14,0,0,0-.06.12c0,.68,0,1.36.08,2s.2,1.34.33,2a13.87,13.87,0,0,0,.52,2,9.06,9.06,0,0,0,.36.91c.16.31.36.55.54.84.08.12.22.05.23-.07h0c0-.12,0-.23,0-.34s0,0,0,0h0a4,4,0,0,0,0-.59c0-.33-.12-.65-.19-1-.14-.64-.32-1.29-.49-1.92s-.31-1.29-.47-1.93-.39-1.3-.54-2a.1.1,0,0,0-.05-.06,3,3,0,0,0,2.92-1.83A5.28,5.28,0,0,0,386.64,218.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.58,235.21a35.84,35.84,0,0,0-4.46-2.68,42.23,42.23,0,0,0-5.05-2.37c-3.4-1.31-6.88-2.16-10.37-3.16-.11,0-.17.15-.06.18,3.39,1.19,6.66,2.83,9.95,4.27,1.61.71,3.25,1.39,4.89,2s3.3,1.42,5,2C396.59,235.49,396.69,235.29,396.58,235.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.73,213.16a28.19,28.19,0,0,1-7-.94c-1-.27-2.09-.61-3.12-.94a8.45,8.45,0,0,1-2.81-1.41c-1.58-1.37-2.32-3.52-3-5.43a51.74,51.74,0,0,1-1.83-6.58c0-.11-.18-.08-.19,0a26,26,0,0,0,.95,7.48c.57,2.06,1.33,4.36,3,5.81a11.79,11.79,0,0,0,6.38,2.33,29.67,29.67,0,0,0,7.59-.1A.13.13,0,0,0,415.73,213.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.73,422.79c-2.88-.38-24.85-1.14-43.23-.35-.12,0-.11.17,0,.18,6,.54,39.84.77,43.21.38C444.82,423,444.86,422.8,444.73,422.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.65,83.22s9.64-5.57,18.39-.35,13.13,18.42,11.86,29.58,7.94,18.35,9.08,26.6-4.22,12.18-6,16.56c-2,5,6.7,22.51-14.51,27-26.51,5.63-37-10.55-34.54-24.13,1.21-6.65,4.85-11.43,4.68-16.79s-4-9.57-2.19-16.4,4.48-6,5.36-16.66S371.26,85.21,380.65,83.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.2,82.65a33,33,0,0,1,12.87,14.9,30.65,30.65,0,0,1,2.43,9.65c.36,4.34-.23,8.43,1.47,12.62,2.72,6.71,8,12.26,7.91,19.8a18.6,18.6,0,0,1-3,9.88c-2.23,3.45-5.46,6.2-7.31,9.88-.08.15-.32,0-.25-.13,1.55-3.27,4.1-5.79,6.21-8.73a18.93,18.93,0,0,0,3.71-11.92c-.34-7.15-5.56-12.56-8.07-19a22.79,22.79,0,0,1-1.22-8.89,32.47,32.47,0,0,0-1.58-10.75,34.87,34.87,0,0,0-13.22-17.18C397.07,82.7,397.14,82.61,397.2,82.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.93,163.76a0,0,0,0,1,0,.05S409.9,163.77,409.93,163.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,156.56c.61-3.21,2.23-6.15,2.84-9.35.73-3.86-.31-7.66-1.12-11.42-1.14-5.36-1.12-10.44,1.16-15.56,1.47-3.3,3.29-6.4,4.36-9.87a40.09,40.09,0,0,0,1.82-11.6.07.07,0,0,1,.14,0A37,37,0,0,1,371,115.32c-1.4,3.05-3.15,5.93-3.92,9.21-.93,3.95-.47,7.73.29,11.65a44.44,44.44,0,0,1,1.14,7.94,22.4,22.4,0,0,1-1.73,7.87,27.55,27.55,0,0,0,.5,20.3c0,.11-.16.2-.21.09A26.21,26.21,0,0,1,365,156.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.68,138.08c-.35-5.89-4.54-9.82-7.13-14.89-1.95-3.82-3.31-7.92-2.77-12.19,0-.07.14-.06.13,0-.2,6.17,2.49,11.71,6,16.8,2.33,3.39,4.27,6.65,4.37,10.78s-1.46,7.48-3.7,10.87c-1.6,2.42-3.17,4.67-3.81,7.5a29.93,29.93,0,0,0-.24,8.61c0,.15-.23.15-.25,0-.47-4.41-.62-8.69,1.53-12.77C417.45,147.79,421,144.07,420.68,138.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,152.39a36.61,36.61,0,0,1,3.28-5.77c2.2-3.36,2.52-6.06,1.7-10a.08.08,0,0,1,.15,0c1.14,3.22,1.45,5.91-.42,8.93-2.6,4.22-5.16,8.07-5.62,13.06-.81,8.85,4.33,17,12.5,21.31.12.06,0,.22-.1.17-6.85-3.22-11.72-9.18-12.85-16.29A21.18,21.18,0,0,1,363.93,152.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,137.58c-6.48,24.92-16.44,49.24-23.16,52.76-9.65,5-31.91,11.4-45.32,11-3.93-.12-7.25-26-3.09-26.67,5.7-.9,33.17-6.91,33.67-7,1.05-.3,24-28.73,27.8-34.74C384.63,122.31,391.48,124.2,388,137.58Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,200.41c-3.17.91-20.27,6-24.6,5.85s-16.74-1.42-17-4.74,3.44-3.24,3.44-3.24-5.16-1.37-5.1-4.73,5.77-3.05,5.77-3.05-5.19-1.8-4.89-5.15,6-2.07,6-2.07-4.83-1.42-3.41-4.08c1.7-3.19,10.3.43,15.09.22,1.08,0,22-2.55,22-2.55Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.18,183.18c6.33,2.65,9.56,2.71,16.22,1.59a.1.1,0,0,1,.06.2c-6.42,1.69-10.49,2.2-16.43-1.49C291.74,183.3,291.88,183.05,292.18,183.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.07,190.28c6.82,2.17,10.32,2.27,17.38,1.61.1,0,.13.16,0,.18-6.88,1.23-10.94,1.64-17.47-1.43C290.72,190.5,290.76,190.18,291.07,190.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.25,198.24c6.76,1.63,10.59,1.9,17.37.38a.13.13,0,0,1,.07.24c-6.76,2.23-11.55,1.92-17.46-.41C290.82,198.29,290.83,198.13,291.25,198.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,173s-7.73-3.76-11.5-4.66-19,.9-18.81,4.22c.26,4.28,9.27,5,13.73,4.74,0,0,.59,9.91,6.95,11.81S330.12,173,330.12,173Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.26,173.68c3.06,3.73,8.89,3,13.23,3.14a.4.4,0,0,1,.39.53c.53,4.13,2.47,9.82,6.37,11.86a.1.1,0,1,1-.07.18c-4.48-1.62-6.85-7-7.14-11.61-4.45,0-10.33.4-12.81-4.07C300.21,173.68,300.24,173.66,300.26,173.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.29,170l6.14,31.71s31.27-6.2,35.52-12.15,16.58-33.05,20.41-51.19-4.92-14.34-12.07-4.87c-7.4,9.79-26,33.48-26.49,33.58S326.29,170,326.29,170Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.22,171a.09.09,0,0,1,.18,0,250.08,250.08,0,0,1,5.53,26.71c0,.09-.15.12-.17,0A250.63,250.63,0,0,1,332.22,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.13,195l1.3,6.7s31.28-6.2,35.52-12.14,16.59-33.06,20.41-51.2c1.95-9.27.6-12.79-2.16-12.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.27,171.67l-.2,18,55.16-.44s-5-40.62-19.37-58.37c-7.48-9.22-16.1-8.26-22-2.51-1.5,1.45-15.23,21.7-17.27,30.49A14.12,14.12,0,0,0,369.27,171.67Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.81,169.49a49.42,49.42,0,0,1,7,1.59c1.14.37,2.24.78,3.35,1.22.55.22,1.11.42,1.67.62a7.42,7.42,0,0,0,1.8.45,0,0,0,0,1,0,.09,12.77,12.77,0,0,1-1.75-.14,13.29,13.29,0,0,1-1.65-.42c-1.16-.36-2.29-.77-3.44-1.14-2.32-.75-4.64-1.49-7-2.07C380.65,169.66,380.69,169.48,380.81,169.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.79,171.25a53.3,53.3,0,0,1,5.93.07c1,.07,2,.2,2.93.35l1.4.25c.51.09,1,.26,1.52.35.05,0,.05.09,0,.08-.48-.07-1-.06-1.47-.1l-1.47-.12-2.95-.25q-2.94-.28-5.89-.47A.08.08,0,0,1,374.79,171.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.13 194.75 428.11 194.31 425.46 187.23 369.09 187.64 367.13 194.75",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.13 194.75 428.11 194.31 425.46 187.23 369.09 187.64 367.13 194.75",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,195.82l-.07-9.36,15.5-.11.07,9.36Zm1.91-7.41,0,5.43,11.58-.08,0-5.44Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.89,126.46s-8.42,27.74-9.12,32.2-11.54,100.06-11.54,100.06l-18.76-9.58c-.07-.31,17.31-46.49,18.49-51.57,3.23-14,5-25.32,5-25.5-.14-.45-6.48-6.48-3.8-14.12,3.61-10.29,11-21.17,15.55-27.38C383.44,126.8,384.89,126.46,384.89,126.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.66,124.4s-.52,35.08-1,38.29,1.46,101.08,1.46,101.08L440.44,256s-11.83-81-29.16-116.72C404.64,125.6,396.66,124.4,396.66,124.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.67,128.34c18.63,20.39,34.54,52.92,32.33,69.26-1.6,11.76-9.51,7.54-11.08,7.18-9.6-2.25-23.37-44.68-27.31-64.05S399.06,123.3,403.67,128.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.77,196.15c-.79-2.21-1.62-4.4-2.37-6.63l-2.33-6.62c-1.54-4.43-3.11-8.84-4.57-13.29s-3-8.88-4.43-13.34c-.72-2.22-1.42-4.46-2.08-6.7s-1.31-4.5-1.94-6.76a126.88,126.88,0,0,0,3.19,13.72c1.26,4.52,2.72,9,4.19,13.44s3.11,8.86,4.82,13.23S413.73,191.92,415.77,196.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.43,148.57a19.21,19.21,0,0,0-1-2.32c-.18-.37-.36-.74-.56-1.11s-.38-.73-.62-1.1a6.35,6.35,0,0,0,.67,2.46A6.87,6.87,0,0,0,399.43,148.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.66,128.92c1.45-5,6.27-5,8.4-4.65,3.69.57,6.28,1.71,6.82,6.67.56,5.22-.23,10.17-1.15,15.32a.76.76,0,0,0,1.49.29c1.06-5.93,3.63-17-1-21.91-3.14-3.35-14-4.68-16.07,4-.23,1,1.21,1.23,1.49.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.35,149.89a3.49,3.49,0,1,1-2.76-4.09A3.5,3.5,0,0,1,400.35,149.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,149.62a2.1,2.1,0,1,1-1.66-2.46A2.09,2.09,0,0,1,399,149.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,146c-1.43,15-3.21,18.13-4.93,19.29a9.61,9.61,0,0,1-4.16,1.41l-.08-1.06,0,.53,0-.53a8.63,8.63,0,0,0,3.65-1.23c1.24-.83,3-3.66,4.47-18.51Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.65,164.35h0a1.11,1.11,0,0,1,1.11,1.11v1.44a1.11,1.11,0,0,1-1.11,1.11h0a1.12,1.12,0,0,1-1.12-1.12v-1.43a1.11,1.11,0,0,1,1.11-1.11Z",
    transform: "matrix(-0.15, -0.99, 0.99, -0.15, 264.32, 559.58)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,143.05c-6.51,9.31-9.24,14.71-8.6,17a8.77,8.77,0,0,0,2,3.31l-.75.75a9.65,9.65,0,0,1-2.25-3.77c-.77-2.73,1.77-7.91,8.74-17.89Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.9,162.47l0,0a1.12,1.12,0,0,0-.11,1.57l.94,1.09a1.12,1.12,0,0,0,1.57.11l0,0a1.11,1.11,0,0,0,.11-1.57l-.94-1.09A1.12,1.12,0,0,0,364.9,162.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.89,141.89a61.6,61.6,0,0,1,4.25-6.09,6.45,6.45,0,0,1,2.89-1.71c.2.06.76-1.71,1.18-3.17.37-1.28.77-2.79,1.22-3.08a1.05,1.05,0,0,1,1.39.43c.2.5-.32,2-.73,3.24-.48,1.44-1,3.21-.82,3.28a6.91,6.91,0,0,1,1.29,3,49.67,49.67,0,0,1-.11,7.6c-.22,1.58-.76,1.59-1.24,1.58-.67,0-.9-.56-.77-2.36.21-2.84.87-7.51-.93-8.15h0c-1.85-.47-4.25,3.85-5.76,6.19-.95,1.47-1.34,1.5-1.9,1.14C371.46,143.55,371.09,143.2,371.89,141.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.22,127.25c-.35,1.09-4.65,8-9.75,7.29-1.66-.22-2.51-9.38-2.51-9.38l-.09-.69-1.32-9.6,11.67-6.18,1.68-.81s.19,2.66.39,6l0,.47c0,.19,0,.36,0,.54,0,.49.07,1,.09,1.5s0,.75.05,1.15,0,.8,0,1.2A61.3,61.3,0,0,1,396.22,127.25Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.29,113.84a19.45,19.45,0,0,1-12.42,10.63l-1.32-9.6,11.67-6.18,1.68-.81S396.09,110.54,396.29,113.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.18,101.61c-.9,17,9.17,19.46,12.84,19.65,3.32.17,14.67.34,17.33-16.47s-5-22.6-12.55-23.4S371.09,84.62,370.18,101.61Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.43,100.75c.4-.07.75-.19,1.14-.29a2,2,0,0,0,1.11-.52.62.62,0,0,0,0-.74,1.48,1.48,0,0,0-1.49-.29,2.16,2.16,0,0,0-1.35.84A.64.64,0,0,0,373.43,100.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,100.68a11.17,11.17,0,0,1-1.16-.17,1.92,1.92,0,0,1-1.16-.4.6.6,0,0,1-.05-.74,1.53,1.53,0,0,1,1.46-.44,2.21,2.21,0,0,1,1.43.69A.64.64,0,0,1,385,100.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,103.88s-.08.06-.08.1c.11,1.16.05,2.5-1,3,0,0,0,.07,0,.06C376.11,106.74,376.18,105,375.88,103.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.77,102.73c-1.87,0-1.78,3.73,0,3.75S376.34,102.75,374.77,102.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,103c-.3.21-.58.58-.93.61s-.73-.36-1-.74c0,0-.05,0-.05,0,0,.72.25,1.45.94,1.57s1.08-.51,1.23-1.23C374.22,103.12,374.11,102.92,374,103Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.45,104c0-.05.1,0,.1.1,0,1.16.16,2.49,1.22,2.86,0,0,0,.07,0,.06C382.47,106.91,382.25,105.14,382.45,104Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.47,102.81c1.86-.18,2.08,3.56.35,3.72S381.91,103,383.47,102.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.26,103c.31.18.62.52,1,.52s.69-.42.93-.82c0,0,.05,0,.06,0,.06.71-.14,1.47-.81,1.65s-1.12-.43-1.33-1.13C384.05,103.14,384.14,102.93,384.26,103Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.74,113.53c-.25.3-.49.7-.9.78a3.22,3.22,0,0,1-1.27-.16,0,0,0,0,0-.05.06,1.57,1.57,0,0,0,1.53.48,1.25,1.25,0,0,0,.81-1.12C382.87,113.5,382.78,113.49,382.74,113.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.7,109.56s-.16,1.74-.12,2.56c0,.08.2.1.48.11h0a3.9,3.9,0,0,0,3.71-1.63c.05-.08-.06-.16-.13-.1a5.85,5.85,0,0,1-3.5,1.17c-.07-.22.37-3,.24-3a7.46,7.46,0,0,0-1.83.51c.23-3.64,1-7.22,1.21-10.85a.11.11,0,0,0-.21,0,59.25,59.25,0,0,0-1.81,11.62C375.73,110.4,377.38,109.71,377.7,109.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.78,106.82a7,7,0,0,1-4.22-5.46,18.25,18.25,0,0,1-7.74-5.55c.13.34,1.09,2.81,1.62,4-10.84-1.4-14.61-9.42-14.61-9.42a18.48,18.48,0,0,0-4.3,7.06s-.44-6.58,2.69-11.17a10.63,10.63,0,0,1,9.55-4.92,15.18,15.18,0,0,1,15.05,3.73C405.21,92.34,399.78,106.82,399.78,106.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.19,98.54a19.92,19.92,0,0,0,5.61,1.72s0,0,0,0a16.89,16.89,0,0,1-8.14-4.32,15.76,15.76,0,0,1-2.49-3.1,11,11,0,0,1-1.66-4,.08.08,0,1,0-.16,0A12.9,12.9,0,0,0,375.44,93,12,12,0,0,0,378,96.42a13.51,13.51,0,0,0,3.17,2.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.78,105.18s3.54-5.44,6-4.19-.08,9-2.87,10.18a2.89,2.89,0,0,1-3.91-1.42Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,103.2a0,0,0,0,1,0,.08c-2,.87-2.94,2.74-3.61,4.67a1.59,1.59,0,0,1,2.36-.51c.05,0,0,.12-.05.11a1.75,1.75,0,0,0-1.92.68,8,8,0,0,0-.88,1.6c-.09.18-.41.1-.35-.11v0C397.44,107.15,399.28,103.55,402,103.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.12,205.87c-6.51,3.41-17,1.17-44.92-7-3.87-1.13-3.23-30.57,1-29.58,5.28,1.26,25.51,7.26,26.93,7.89C428.1,182.46,437.53,203.56,433.12,205.87Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.89,174.26s-9.5-6.57-15.55-8.48a40.84,40.84,0,0,0-19.51-.74c-7,1.42-22.89,9.67-21.31,14.67,1.43,4.52,17.26-4.74,17.26-4.74s-17.7,6.78-15,11.91,20.49-6.67,20.49-6.67-18,7.37-14.39,12.22c2.76,3.66,19.45-6.11,19.45-6.11s-15.45,6.44-12.78,10.33c2.94,4.29,18.92-3.76,18.92-3.76,8.45,8.74,16.22,9.25,21.69,9.11C400.5,202,399.89,174.26,399.89,174.26Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.75,172.24c-2.1.72-4.24,1.43-6.28,2.34s-4,1.88-6,3a37.77,37.77,0,0,0-7.15,5c4.13-3.13,11.37-6.49,13.41-7.39s4-1.91,6.05-2.82C366.84,172.29,366.8,172.22,366.75,172.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.16,179.53c-2.66,1-5.33,2-7.93,3.12s-5,2.47-7.47,3.79c-.19.11-.07.18.13.08,2.56-1.22,5-2.15,7.59-3.35s5.1-2.48,7.71-3.58C370.23,179.58,370.2,179.52,370.16,179.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.2,185.27a63.17,63.17,0,0,0-11.76,5.7c-.18.11,0,.18.18.08,3.87-2,6.89-3.54,11.63-5.64C374.33,185.38,374.29,185.24,374.2,185.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.62,170.75l2.74,34.91s28.36,5.34,32.22-.17-6.15-22.64-14.52-27.52C415.57,175.93,398.62,170.75,398.62,170.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.71,171.91l0-1.17-.08.06c2.86,1,5.72,2,8.57,3s5.69,2.06,8.46,3.23a35,35,0,0,1,4.05,1.92,25.91,25.91,0,0,1,3.62,2.63,29.09,29.09,0,0,1,5.7,7,24,24,0,0,0-5.27-7.43,21.23,21.23,0,0,0-3.65-2.81,33.61,33.61,0,0,0-4.12-2.05c-2.82-1.16-5.68-2.16-8.57-3.1s-5.81-1.76-8.76-2.49l-.08,0v.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.59,176.78c0,1.75.2,3.51.34,5.26s.28,3.5.45,5.25c.35,3.49.71,7,1.12,10.46.11,1,.22,1.91.35,2.86s.4,2,.53,3c0,.08.13.06.13,0-.07-.86,0-1.73-.07-2.6s-.13-1.78-.21-2.67c-.15-1.75-.31-3.5-.48-5.24-.34-3.49-.7-7-1.15-10.47-.26-2-.46-3.95-.83-5.9A.09.09,0,0,0,406.59,176.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,202.56c.2,1,.36,2.05.49,3.08l-.21-.22c6.05.86,12.13,1.54,18.23,1.86a66.07,66.07,0,0,0,9.12-.1c1.45-.2,3.08-.2,4.22-1.23a6.59,6.59,0,0,0,1.86-4,6.54,6.54,0,0,1-1.65,4.25c-4.95,3.86-25.34.9-31.86-.26l-.2,0c0-1.1,0-2.21,0-3.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.63,364.31,60,402.44c-3.86,7.72-7.1,14.56-8.44,18.25a.14.14,0,0,0,0,.06,5.94,5.94,0,0,0-.62,2.67.08.08,0,0,0,0,.07c1.52,2.71,62.31,35.3,64.81,35.72s3.91-6.68,2.56-9.82-19.06-26-19.06-26l23.2-38.28Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.78,459.21c-2.5-.42-63.29-33-64.82-35.72a.64.64,0,0,1,0-.07,6.27,6.27,0,0,1,.63-2.66.14.14,0,0,1,0-.07c1.34-3.7,4.58-10.52,8.43-18.24l4-6.52,39,21.12-3.81,6.29s17.69,22.89,19.06,26S118.29,459.65,115.78,459.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.69,461c-2.6-.47-65.43-35-67-37.84-.61-1.06,3.89-10.51,9.66-21.77l.18-.35,40.79,21.82-.4.68s18.14,24,19.52,27.27S119.29,461.47,116.69,461Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.32,458.17c-10.45-6.08-53.17-29.62-64-34.84-.08,0-.12,0,0,.07,10.22,6.25,53.13,29.44,63.9,34.94C117.45,458.46,117.54,458.3,117.32,458.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.27,425.54c-3.74-3.07-9.19-5.23-14-4-.18.05-.11.32,0,.35A66.66,66.66,0,0,1,103,426.05.3.3,0,0,0,103.27,425.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,429c-3.74-3.07-9.19-5.23-14-4-.19.05-.12.31,0,.34A67.6,67.6,0,0,1,105,429.52.3.3,0,0,0,105.28,429Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.29,432.47c-3.74-3.07-9.19-5.23-14-4-.19,0-.12.31,0,.34A66.35,66.35,0,0,1,107,433,.3.3,0,0,0,107.29,432.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.05,413.78c-3.31-4.79-10.74.34-7.43,5.13S69.35,418.56,66.05,413.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.64,427.14l3.81,28.73A114.42,114.42,0,0,0,116.69,461c2.6.47,4.13-6.91,2.77-10.19C118.41,448.32,107.75,434,102.64,427.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.42,398.44l45.84,24.48s61.74-89.4,62.9-111.07c1.6-29.92-23.95-124.91-23.95-124.91l-40.75-.28S121,284.35,119.68,301C119,309.74,60.42,398.44,60.42,398.44Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.26,413.44c-2.36-1.7-24.09-14.29-40.63-22.33a.1.1,0,0,0-.09.17c5,3.31,37.45,21.08,40.6,22.34C110.25,413.66,110.37,413.52,110.26,413.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.34,280.15q-2.84-21.45-6.35-42.8c-2.39-14.28-4.9-28.56-7.89-42.74q-.55-2.6-1.13-5.19a.21.21,0,0,0-.41.09c2.51,14.06,5.09,28.11,7.4,42.21s4.47,28.22,6.4,42.38q.72,5.25,1.4,10.52a92.79,92.79,0,0,1,1,10.91,27.85,27.85,0,0,1-1.75,10.23,59,59,0,0,1-4.69,9.2c-7.37,12.47-44.27,73.92-45.13,75.5,0,.11.09.21.16.11,7.92-12.29,36.38-58.5,43.86-71.18,3.37-5.71,7.23-11.5,8.33-18.17C127.73,294.28,126.25,287,125.34,280.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.6,391.5s-.46,45.87-.46,45.9c.24,8.77.61,16.46,1.18,20.42a.13.13,0,0,0,0,.06,6.07,6.07,0,0,0,.72,2.69l0,.06c2.66,1.69,72.83,1.8,75.27,1s.31-7.86-2.41-10-29.58-14.23-29.58-14.23l0-45.84Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.23,428s-.09,9.39-.09,9.42c.24,8.77.61,16.46,1.18,20.42a.13.13,0,0,0,0,.06,11.46,11.46,0,0,0,.72,2.69l0,.06c2.66,1.69,72.83,1.8,75.27,1s.31-7.86-2.41-10-29.58-14.23-29.58-14.23v-9.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.59,462.48c-2.51.83-74.2.31-76.92-1.45-1-.65-1.57-11.1-1.86-23.75v-.39l46.26-.18,0,.78S186.4,450,189.18,452.21,194.1,461.66,191.59,462.48Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,459.69c-12.08-.38-60.86-.79-72.83-.25-.1,0-.1.07,0,.07,12,.65,60.74.66,72.83.38C191.05,459.89,191.06,459.7,190.8,459.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,437.66c-4.75-.92-10.57-.24-14.23,3.13-.14.13,0,.33.2.28a66.67,66.67,0,0,1,14-2.81A.3.3,0,0,0,162.93,437.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35,439.75c-4.75-.92-10.57-.23-14.23,3.13-.15.13,0,.33.2.28a67.35,67.35,0,0,1,14-2.81A.3.3,0,0,0,166.35,439.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,441.85c-4.74-.93-10.57-.24-14.23,3.12-.14.13.05.33.2.29a66.29,66.29,0,0,1,14-2.81A.3.3,0,0,0,169.76,441.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59,445c-5.18-2.63-9.29,5.41-4.1,8.05S129.78,447.64,124.59,445Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7,186.85s0,0,0,0c-.27.84-14.91,41-16.29,41.61-1.56.72,32.35,57.69,34.36,84.15,1.28,16.93-1.23,120.45-1.23,120.45H111.93s2.38-93.85,3.52-121.13c.44-10.59-34-63.27-34.47-96.08-.13-10.34,7.3-29.23,7.3-29.23Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73,311.23c0-.44-.34-.58-.38-.13-1.12,14.76-1.38,29.45-2.08,44.25s-.31,18.3-1,33c-.38,8.35,0,24.44-.22,32.8a.11.11,0,0,0,.21,0C113.84,406.49,115.72,319.59,115.73,311.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.75,313.24a73.22,73.22,0,0,0-1-10.87,53.59,53.59,0,0,0-3.07-10.21c-2.74-6.91-6-13.65-9.07-20.4s-6.33-13.65-9.64-20.41q-2.79-5.7-5.61-11.39c-1.91-3.83-4-7.59-6-11.38a.13.13,0,0,0-.24.12c3.18,6.82,6.31,13.66,9.49,20.49s6.3,13.67,9.42,20.52,6.15,13.48,9,20.29a66.37,66.37,0,0,1,3.54,10,57.83,57.83,0,0,1,1.45,10.8c.48,8.47.72,17,1.55,25.41,0,.11.18.09.19,0C163.1,328.58,163,320.88,162.75,313.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.92,423.3c-2.88-.38-24.85-1.13-43.23-.35-.12,0-.11.18,0,.19,6,.53,39.83.76,43.2.37C158,423.5,158.05,423.32,157.92,423.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.24,226.27a94.77,94.77,0,0,0-15.5,5.38.17.17,0,0,0,.1.32c5.21-1.63,10.5-3.16,15.61-5.08A.33.33,0,0,0,135.24,226.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.24,192.28c0-.17-.29-.24-.31-.05-.57,5.92-1.48,11.09-2.54,16.57-.5,2.54-4,16.52-8.36,15-.73-.25-1-1-1-2.16a18,18,0,0,1,1-4.29c.8-2.92,1.5-5.86,2.06-8.84a81.7,81.7,0,0,0,1.54-16.8.15.15,0,0,0-.29,0,154.57,154.57,0,0,1-3.73,23c-.93,3.63-3.36,9,.44,10s7.37-8.06,8.11-10.56A85.1,85.1,0,0,0,140.24,192.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,224.22a24.34,24.34,0,0,0-1.31,2.84,6.67,6.67,0,0,0-.66,2.37.17.17,0,0,0,.3.1,8.86,8.86,0,0,0,1.28-2.24c.43-.88.88-1.75,1.29-2.63A.5.5,0,0,0,129.11,224.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.81,325.8c.25-7.05,1-14.44-1.28-21.25A70,70,0,0,0,115,294.9q-2.58-5-5.06-10c-6.62-13.38-12.87-27-18.44-40.82-2.69-6.68-5.09-13.52-6.05-20.68a63.56,63.56,0,0,1,1.39-22.49c.42-1.84.86-3.66,1.36-5.48,0-.13-.16-.2-.2-.07a74,74,0,0,0-3.87,21.51,60.72,60.72,0,0,0,3.73,20.56c2.38,6.92,5.36,13.65,8.29,20.35q4.53,10.35,9.42,20.55c3.24,6.76,6.7,13.41,10.12,20.08a36.25,36.25,0,0,1,3.81,10.14,52.05,52.05,0,0,1,.41,11.09c-.59,15.6-1.93,75.22-2.13,90.77,0,2-.05,3.95-.07,5.93,0,.17.26.2.27,0C119,400.85,120.25,341.35,120.81,325.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.69,197c0-.12-.18-.09-.19,0-.58,4.29-.92,8.74-3,12.63-1.9,3.57-5.22,5.88-8.83,7.49a64.52,64.52,0,0,1-6.44,2.37c-.16.05-.12.3.05.26,4.1-.85,8.27-1.8,11.84-4.11,3.81-2.46,5.77-6.41,6.4-10.83A37.86,37.86,0,0,0,109.69,197Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.21,214.47,84.43,197.92c1.88-6.26,3.85-11.26,3.85-11.26l16.19.05a.18.18,0,0,1,0-.05l15.56.11,24.68.08s0,0,0,0a.43.43,0,0,0,0,.05h.54S148.27,198.33,152.21,214.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.61,132.14c-.5,18.15,11.25,51.37,17.63,57.26,7.86,7.26,36,9.65,37.87,9.92,3.07.44,4.88-28.16,2-29.12-3.5-1.16-23.61-2.77-25.68-5.41-5-6.36-12.11-18.45-20.85-33.15C154.79,123.63,148.92,120.85,148.61,132.14Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.9,198.9c3.11,1.08,17.8,4.78,22.11,4.9s16.76-.45,17.19-3.75-3.23-3.42-3.23-3.42,5.21-1.08,5.34-4.43-5.57-3.37-5.57-3.37,5.28-1.49,5.16-4.85-5.84-2.4-5.84-2.4,4.89-1.14,3.63-3.87c-1.52-3.28-10.29-.16-15.05-.65-1.08-.11-21.73-3.79-21.73-3.79Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.55,181.5c-6.46,2.28-9.68,2.16-16.25.66-.13,0-.2.16-.07.2,6.3,2,10.32,2.79,16.45-.55C239,181.65,238.86,181.4,238.55,181.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.25,188.64c-6.92,1.78-10.41,1.68-17.41.62-.1,0-.14.15,0,.17,6.78,1.62,10.81,2.26,17.48-.43C239.59,188.88,239.56,188.56,239.25,188.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.61,196.56c-6.82,1.24-10.65,1.29-17.32-.61a.13.13,0,0,0-.08.24c6.6,2.6,11.39,2.57,17.42.58C239,196.64,239,196.48,238.61,196.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.62,171.76s7.51-4.15,11.21-5.24,19-.09,19,3.22c0,4.29-9,5.45-13.43,5.44,0,0-.08,9.91-6.32,12.13S199.62,171.76,199.62,171.76Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.41,170.92c-2.85,3.88-8.7,3.49-13,3.81a.4.4,0,0,0-.36.55c-.31,4.15-2,9.91-5.74,12.15a.1.1,0,0,0,.09.18c4.38-1.85,6.46-7.38,6.51-12,4.44-.25,10.32-.13,12.56-4.72A0,0,0,0,0,229.41,170.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.15,149.5l-21,16.07s-4.93-28.68-4-37.53c1.05-9.95,5.91-7.24,12,.11S172.15,149.5,172.15,149.5Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5,146.27c-2.95,1.68-11.1,8-12.46,9-.72.54-3.47,2.83-4.19,3.36-.09.07,0,.2.12.13,1.37-1,2.85-1.9,4.23-2.91s9.9-7.12,12.38-9.49A.06.06,0,0,0,168.5,146.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.13,128c-.94,8.84,4,37.53,4,37.53L162,157.29,152.53,122C149.74,120.67,147.76,122.1,147.13,128Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.45,193.58S152.16,213,152.16,213c-.38,1.35,7.45-46.22,5.24-81-.66-10.29-12.08-17.78-23.51-9.69C109.84,139.28,83.21,194.45,83.45,193.58Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.86,133.91c-4,16.72-13.23,51.2-7,62.33,8.14,14.59,38.44,26.61,46.35,30.09,3.44,1.51,14.87-20.8,13.21-24.47S148.57,182.28,146.56,180s-2.5-30.22-4.14-44.71C140.35,117,132.22,119.75,128.86,133.91Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.37,210.93c-1.14-1.54-.34-2.15,2.95-1.26s15.59,7.2,17.43,2.73-15.63-13.13-21.23-14.19-15-.82-15-.82C177.55,199.76,184.43,206.21,190.37,210.93Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.63,221.71c8.87,6.35,19.52,14.8,31.78,15.9a6.07,6.07,0,0,0,3.89-.86c5.49.59,7.42-1.82,7.42-1.82,5.27-1,6.9-3.75,6.9-3.75s6.45.62,7.47-3.21c1.17-4.3-8.11-4.34-13.21-7.48-11.66-7.19-26.23-20.69-29.39-23.1Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.36,221.54a86.17,86.17,0,0,0,10.57,5.72,88.33,88.33,0,0,0,12.61,3.79.11.11,0,0,1,0,.21,46.59,46.59,0,0,1-23.24-9.56C186.11,221.58,186.18,221.44,186.36,221.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,228c3.49,1.81,9.65,5,21.75,6.85,0,0,0,.07,0,.07a41.89,41.89,0,0,1-21.83-6.75C180.7,228,180.76,227.83,181,228Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.17,231.45c6.06,2.85,10.23,3.88,17.11,5.26,0,0,0,.08,0,.08-8-.76-10.8-1.94-17.24-5.14C177.82,231.54,177.93,231.34,178.17,231.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.47,155.21l-25.53,6.18s7-28,11.4-35.68c4.94-8.62,8.26-4.21,10.82,4.88S145.47,155.21,145.47,155.21Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.45,150.81c-3.35.35-13.28,2.81-14.92,3.19-.87.21-4.29,1.18-5.15,1.38-.12,0-.06.19.05.17,1.66-.38,3.35-.59,5-1s11.85-2.5,15-3.66A.07.07,0,0,0,143.45,150.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.13,136.53c0-.12-.14-.15-.18,0q-1.29,3.45-2.43,6.95a20.63,20.63,0,0,1,.67-3.79,0,0,0,1,0-.08,0,17.51,17.51,0,0,0-.78,4.38q-.8,2.44-1.54,4.9c-1.26,4.16-2.57,8.33-3.59,12.56a.3.3,0,0,0,.37.36c.88-.25,1.75-.51,2.61-.82.09,0,.08-.18,0-.17-.75.09-1.49.21-2.23.34,1.32-4,2.44-8.06,3.65-12.08S126,140.75,127.13,136.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94,144c0-1.39.05-2.77,0-4.16a0,0,0,1,0,0,0c-.06,1-.09,2-.12,3.06-.27-2-.58-4-1-6,0,0,0,0,0,0,.16,3.08.49,6.14.72,9.22s.5,6,.78,9c-.56.23-1.12.45-1.69.66a.09.09,0,0,0,0,.17c.65-.13,1.3-.25,2-.35a.3.3,0,0,0,.28-.3C145.71,151.5,145.41,147.71,144.94,144Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.24,133.75c-3.49.11-11-6.27-12.45-11.51-.09-.36,1.2-3.59,2.59-7.58.83-2.43,1.7-5.16,2.32-7.7.12-.52,15,7.73,15,7.73a42,42,0,0,0-3.9,9.39,5.82,5.82,0,0,0-.14,1.07s0,.11,0,.18C156.5,127.39,157,133.62,153.24,133.75Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67,125.15s0,.11,0,.18A12.44,12.44,0,0,1,155,125c-9.34-2.48-9-14.83-8.74-17.92,2.74,1.09,14.45,7.59,14.45,7.59a41.47,41.47,0,0,0-3.9,9.39A5.93,5.93,0,0,0,156.67,125.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.52,86.45c-2.93,5.33-3.34,22.41-.06,26.92,4.77,6.54,14.28,9,20.27,2.93,5.8-5.93,6-28.2,2.12-32.47C164.21,77.53,151.84,78.57,147.52,86.45Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.52,99.64s-.09,0-.09.1c0,1.15-.19,2.47-1.24,2.82,0,0,0,.07,0,.06C161.47,102.48,161.71,100.73,161.52,99.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.53,98.41c-1.85-.2-2.1,3.51-.39,3.69S162.07,98.57,160.53,98.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.15,100.28s.09.06.08.11c-.11,1.14,0,2.47,1,2.93,0,0,0,.07,0,.06C167.92,103.11,167.86,101.35,168.15,100.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.26,99.15c1.86,0,1.75,3.7,0,3.71S167.7,99.16,169.26,99.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.18,96.61a12.85,12.85,0,0,0,1.47-.41,2.43,2.43,0,0,0,1.42-.7.78.78,0,0,0-.06-1,1.93,1.93,0,0,0-1.95-.34,2.86,2.86,0,0,0-1.73,1.12A.84.84,0,0,0,159.18,96.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.82,97.38a14.48,14.48,0,0,1-1.45-.48,2.51,2.51,0,0,1-1.38-.77.8.8,0,0,1,.11-1,2,2,0,0,1,2-.23,2.85,2.85,0,0,1,1.67,1.21A.83.83,0,0,1,170.82,97.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.73,110.22c.25.29.5.68.92.74a3.13,3.13,0,0,0,1.25-.2,0,0,0,0,1,0,.06,1.55,1.55,0,0,1-1.5.52,1.22,1.22,0,0,1-.84-1.07C159.6,110.2,159.69,110.18,159.73,110.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.17,106.87a3.87,3.87,0,0,0,2.49,1.91,4.4,4.4,0,0,0,1.4.16,1.17,1.17,0,0,0,.27,0l.26,0a.31.31,0,0,0,.25-.24h0a.53.53,0,0,0,0-.12h0v-.1c.08-.88.09-2.23.09-2.23.31.18,1.91,1,1.91.57a59,59,0,0,0-.7-11.93.11.11,0,0,0-.22,0c-.17,3.69.3,7.39.18,11.09a7,7,0,0,0-1.81-.68c-.13,0,0,2.61,0,3a.1.1,0,0,1,0,0,5.43,5.43,0,0,1-4-1.53C161.2,106.7,161.11,106.77,161.17,106.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.85,108.69a5,5,0,0,1-2.14,1.38,2.25,2.25,0,0,1-1.38,0c-1-.35-.91-1.26-.66-2a5.28,5.28,0,0,1,.55-1.16A6.47,6.47,0,0,0,164.85,108.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.71,110.07a2.25,2.25,0,0,1-1.38,0c-1-.35-.91-1.26-.66-2A2.33,2.33,0,0,1,162.71,110.07Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.15,96.69c1.66-3,.75-8.78,2.62-10,4-2.54,10.16,4.74,15.07,5.63,4.76.86,6.88-1.92,6.7-5.94s-3-7.19-8.23-8.92c-5.38-1.79-10.81-.44-13.86.83,0,0,1.54-1.72,1.19-2.39s-3,.77-3.85,1.43a7.24,7.24,0,0,0-1.57,2.1,7.43,7.43,0,0,0-2.13-.61,4.62,4.62,0,0,0-3.05.77c-.14.27,1.56.8,2.76,1.07,0,0-2.79,2.61-3.19,5.2s1.47,15.52,2.41,15.82C147.23,102.11,150.47,97.93,151.15,96.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.33,80.48s.09,0,0,.08a8.3,8.3,0,0,0-3.22,3.19,10.27,10.27,0,0,0-1,5.3c.16,3.52,1.28,6.87,2.17,10.25,0,.1-.14.14-.17,0-1.18-3.52-2.33-7.31-2.36-11C142.82,85.12,144.15,81.7,147.33,80.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.8,85.45a11.9,11.9,0,0,1,4.27,1A17.16,17.16,0,0,1,161.46,89a16.77,16.77,0,0,0,8.38,4s0,.06,0,.06a14.68,14.68,0,0,1-7.89-3.19,36.36,36.36,0,0,0-3.48-2.7,15.3,15.3,0,0,0-4.69-1.39A.13.13,0,0,1,153.8,85.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.62,77.5a23.23,23.23,0,0,1,6.47-1,18.1,18.1,0,0,1,6.2.86c3.43,1.2,6.28,4,6.47,7.78a7.8,7.8,0,0,1-1.68,5.38c-.08.1-.23,0-.16-.13a8.07,8.07,0,0,0-.17-9.67c-2.46-3-6.49-3.92-10.2-4a33.54,33.54,0,0,0-6.92.74S156.61,77.51,156.62,77.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.85,100.91s-2.74-6-5.41-5.16-1.31,9.14,1.33,10.74a3,3,0,0,0,4.17-.83Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.89,98.11s-.07,0,0,.07c1.84,1.18,2.55,3.23,2.92,5.29a1.62,1.62,0,0,0-2.3-.89.06.06,0,0,0,0,.12,1.81,1.81,0,0,1,1.84,1,8.22,8.22,0,0,1,.64,1.76c.06.19.4.16.37-.06v0C147.88,102.81,146.57,98.87,143.89,98.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.17 117.33 154.28 132.5 156.65 125.33 158.97 129.32 157.48 137.25 154.37 133.52 150.45 139.05 137.57 121.51 142.17 117.33",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.17 117.33 154.28 132.5 156.65 125.33 158.97 129.32 157.48 137.25 154.37 133.52 150.45 139.05 137.57 121.51 142.17 117.33",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.06,461.8c-33,0-59.79-33.47-59.79-74.62s26.82-74.62,59.79-74.62,59.79,33.48,59.79,74.62S330,461.8,297.06,461.8Zm0-143.26c-29.67,0-53.8,30.79-53.8,68.64s24.13,68.64,53.8,68.64,53.8-30.79,53.8-68.64S326.73,318.54,297.06,318.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.78,453.33c-29.17,0-52.9-29.67-52.9-66.15S272.61,321,301.78,321s52.89,29.68,52.89,66.15S330.94,453.33,301.78,453.33Zm0-128c-26.81,0-48.62,27.75-48.62,61.87s21.81,61.88,48.62,61.88,48.62-27.76,48.62-61.88S328.59,325.31,301.78,325.31Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.74,
    cy: 387.18,
    rx: 8.58,
    ry: 10.81,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.06,387.18c0,6-3.84,10.82-8.57,10.82s-8.58-4.85-8.58-10.82,3.84-10.81,8.58-10.81S311.06,381.21,311.06,387.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.49,
    y: 385.05,
    width: 77.65,
    height: 4.27,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.55,
    cy: 449.78,
    rx: 11.16,
    ry: 14.07,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.12,
    cy: 449.78,
    rx: 11.16,
    ry: 14.07,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.44,
    y: 288.07,
    width: 88.35,
    height: 34.11,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.46,404.23h-74V400h74a12.16,12.16,0,0,0,12.15-12.14V212.28A16.44,16.44,0,0,1,317,195.86h10v4.27H317a12.16,12.16,0,0,0-12.14,12.15V387.82A16.44,16.44,0,0,1,288.46,404.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.57,435.72H212.3V267.31a14.8,14.8,0,0,1,14.78-14.79h75.66v4.28H227.08a10.52,10.52,0,0,0-10.51,10.51Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.76,
    y: 193.6,
    width: 26.48,
    height: 8.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.66,
    y: 212.15,
    width: 75.48,
    height: 103.4,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.33,
    y: 444.79,
    width: 94.48,
    height: 9.99,
    transform: "translate(477.14 899.57) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,169c-10.28,10.46-12.45,50.43-16.16,63.94-2.5,9.14-10.56,35.15-16,44.42L277,273.67s6.56-11.1,3.57-34.82C277.53,214.92,262,169,262,169Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,169c-10.28,10.46-12.45,50.43-16.16,63.94-2.5,9.14-10.56,35.15-16,44.42L277,273.67s6.56-11.1,3.57-34.82C277.53,214.92,262,169,262,169Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.13,464.57c2.55.82,75.18.18,77.93-1.59,1.05-.67,1.57-11.25,1.84-24.06.06-2.76,5.55-47.33,5.55-47.33l-48.56.29-3.81,47.32s-27.7,12.68-30.51,14.95S144.59,463.74,147.13,464.57Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.14,464.57c2.54.82,75.16.18,77.92-1.59.79-.51,1.29-6.7,1.61-15.26-9.4,2.15-62.2,6.49-68.27,5.76-5.87-.7,7.72-7.69,10.18-8.93-8,3.76-17.43,8.32-19,9.6C146.77,456.42,144.59,463.74,147.14,464.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.39,215.84s13.61,22,6.63,42c-11.92,34.21-68.65,66.38-69.58,70.78-2.19,10.38-4.76,97.84-4.76,97.84l-52.27-.33s3.67-93.77,10.63-113.88c5.58-16.1,54.06-52.46,66.76-67.05,1.48-1.69,2.58-20.72,2.58-20.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.57,417.07c8.43-.17,33.93-.87,45.16,0,.08,0,.08.14,0,.16-3.85.6-36.73.19-45.16,0A.12.12,0,0,1,183.57,417.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.68,368.89q.6-11.77,1.42-23.54.39-5.79.86-11.57a21.88,21.88,0,0,1,.69-5.53,8.71,8.71,0,0,1,2.52-3.43c5.46-5.05,11.21-9.81,16.87-14.63s11.42-9.72,17-14.67,10.94-9.77,16.13-14.95c4.86-4.86,9.51-10.13,12.64-16.31a46.17,46.17,0,0,0,1.36-37.69c-.6-1.46-1.2-2.91-1.9-4.33a.19.19,0,0,1,.34-.19c6.85,10.61,8,24.72,4.21,36.63-4.3,13.36-15.09,23.09-25.14,32.31-11.14,10.23-22.9,19.75-34.38,29.59q-2.1,1.8-4.18,3.62a18.66,18.66,0,0,0-3.64,3.57c-1,1.58-.9,3.66-1,5.47q-.23,3-.44,6-.86,11.76-1.53,23.53c-.89,15.83-1.19,46.33-1.25,48.27a.3.3,0,0,1-.6,0C226.71,395.27,225.88,384.6,226.68,368.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.27,464.92c2.67.22,75-17.76,77.27-20.12a.89.89,0,0,0,.18-.49c.32-2.35-27-66.18-27-66.18l-43.22,11.26,19.06,43.29s-24.06,18.69-26.27,21.54S258.61,464.7,261.27,464.92Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.27,464.92c2.67.21,75-17.76,77.27-20.12a1,1,0,0,0,.18-.49c.1-.77-2.32-8.11-5.63-17.65-13.63,10.52-63.37,25.84-64.8,25s5.49-8,6-8.47c-6,4.8-11.94,9.71-13,11.06C259.07,457.08,258.61,464.7,261.27,464.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.35,426.45l51-9.88S284.18,323.27,285,316.45c.76-6,34.83-43.91,38.84-58.82,4.33-16.09-2.21-35.34-9.31-44.86l-54.19,11.71s2.5,9.76,10.07,16.23c0,0-37.94,54.84-40,73.57S282.35,426.45,282.35,426.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,416.59c7.09-1.55,5-1.22,12.14-2.68,3.47-.72,26.33-5.4,29.7-5.45.07,0,.1.13,0,.16-3.14,1.23-26.08,5.48-29.57,6.12-7.14,1.31-5.1.85-12.25,2.08C281.88,416.84,281.84,416.62,282,416.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,239.66a99.3,99.3,0,0,1,15.62,5.9.17.17,0,0,1-.13.31c-5.25-1.81-10.59-3.52-15.73-5.6A.33.33,0,0,1,263,239.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.23,237.81a24,24,0,0,1,1.21,2.86A6.54,6.54,0,0,1,271,243c0,.15-.22.18-.32.08a8.5,8.5,0,0,1-1.2-2.27c-.4-.88-.82-1.75-1.2-2.64C268,237.62,268.94,237.25,269.23,237.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.52,221.22c0-.09.18-.14.2,0a72.91,72.91,0,0,0,1.86,8.62c.35,1.32,2.77,8.55,5.47,7.64.45-.15.63-.56.61-1.16a7.9,7.9,0,0,0-.72-2.22c-.55-1.51-1-3-1.43-4.58a36.18,36.18,0,0,1-1.24-8.77c0-.1.17-.11.19,0a67.9,67.9,0,0,0,2.7,12c.64,1.88,2.25,4.63-.11,5.24s-4.74-4-5.25-5.3A38.13,38.13,0,0,1,261.52,221.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.41,237.11c-.83-.5-2.17-.2-3.1-.22a26.76,26.76,0,0,1-3.58-.33,27.67,27.67,0,0,1-3.47-.8,7.7,7.7,0,0,1-3.16-1.53,17.28,17.28,0,0,1-3.38-5.35,26.6,26.6,0,0,1-2.18-6.48c0-.13-.22-.08-.2,0,.14,1.26.18,2.51.43,3.77a23.38,23.38,0,0,0,1,3.47c.78,2.1,1.7,4.37,3.44,5.87s4.5,2,6.82,2.34a27.44,27.44,0,0,0,4.05.24c1,0,2.59.14,3.35-.57A.3.3,0,0,0,309.41,237.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4,311.17a18.11,18.11,0,0,1,1.39-4.89c1.34-3.13,2.89-6.18,4.4-9.23a359.57,359.57,0,0,1,20.36-35.58c4.19-6.47,8.56-12.81,13.34-18.86.18-.22.55,0,.39.24-3.78,5.61-7.59,11.2-11.26,16.87s-7.18,11.48-10.54,17.35S241,288.77,238,294.75c-1.51,3-3,6-4.45,9a50.81,50.81,0,0,0-2.08,4.72,16.13,16.13,0,0,0-.83,5.17c-.1,7.51,5.44,21.63,6.06,23.47a.15.15,0,0,1-.27.11c-2.84-5-6.41-17.35-6.85-20.78A21.13,21.13,0,0,1,229.4,311.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.9,311.17c.45-3.37,2.1-6.48,3.56-9.5s2.91-5.91,4.42-8.84q4.53-8.81,9.57-17.32t10.49-16.78c1.84-2.78,3.72-5.54,5.66-8.25,1-1.35,2-2.7,3-4,.48-.63,1-1.27,1.44-1.89l.8-1c.06-.07.29-.31.29-.38-.22-.43-.39-.48-.52-.14l-.2.3c-3.78,5.6-7.59,11.19-11.24,16.87s-7.07,11.36-10.39,17.16-6.48,11.72-9.5,17.7q-2.28,4.53-4.47,9.09a38.2,38.2,0,0,0-1.9,4.42,16.39,16.39,0,0,0-.76,4.51c-.17,4.28,1,8.62,2.19,12.69,1,3.53,2.23,7,3.49,10.44a3.49,3.49,0,0,1,.35,1l.15-.35-.08.06.35-.15h-.1l.35.14a3.07,3.07,0,0,1-.48-.85l-.48-1c-.35-.76-.67-1.53-1-2.31-.69-1.74-1.32-3.51-1.9-5.29a92.73,92.73,0,0,1-2.7-9.69,21,21,0,0,1-.37-6.62c.08-.63-.93-.63-1,0a23.65,23.65,0,0,0,.69,8.16c.61,2.56,1.35,5.1,2.16,7.61a80.21,80.21,0,0,0,2.87,7.81c.23.54.48,1.08.74,1.61s.41,1.07.8,1.32a.65.65,0,0,0,1-.71,4.14,4.14,0,0,0-.21-.59c-1.57-4.33-3.1-8.68-4.27-13.14a45.24,45.24,0,0,1-1.5-7.91,18.34,18.34,0,0,1,.22-4.74,24,24,0,0,1,2.16-5.74c3.64-7.59,7.45-15.1,11.53-22.47s8.3-14.47,12.8-21.49c2.29-3.56,4.63-7.08,7-10.59q1.77-2.64,3.55-5.27l.82-1.22c.22-.33.61-.72.58-1.14a.73.73,0,0,0-1.22-.45,6.3,6.3,0,0,0-.86,1.07l-1,1.23L264.91,247c-1.2,1.63-2.39,3.27-3.55,4.93-2.37,3.38-4.65,6.82-6.88,10.29-4.47,7-8.74,14.05-12.74,21.28q-3,5.37-5.76,10.85c-1.89,3.75-3.81,7.5-5.47,11.35a20.66,20.66,0,0,0-1.61,5.48C228.82,311.81,229.82,311.8,229.9,311.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,313.75c1.37-2.95,3.6-5.58,5.47-8.23l6.05-8.64c4.08-5.8,8.11-11.64,12.18-17.44,3.82-5.44,7.83-10.8,10.95-16.68s5.05-12.11,4.88-18.67c-.23-9-4.71-24.25-5.4-25.86a.09.09,0,0,1,.15-.08c2,3,9.46,26.48,4.34,38.63a92.39,92.39,0,0,1-9.27,16.75c-4,5.74-8.09,11.4-12.13,17.1L283.35,308c-1.79,2.53-4.34,5.29-4.78,8.48-.48,3.39,1.71,6.74,3.14,9.66q9.36,19.13,18.8,38.21c6.3,12.72,18.41,37.81,19.16,39.37.07.16-.16.29-.24.13-6.66-12.53-11.09-21.71-17.42-34.41s-12.56-25.32-18.76-38c-1.51-3.1-3.14-6.17-4.5-9.33C277.55,319.32,277.13,316.57,278.43,313.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.82,132.1c6.48,5.11,9.25,14.44,9.25,14.44s6.69,8.94,5.73,14.32a9.55,9.55,0,0,1-5.29,7.11l.22-2.94s-1.44,3.91-7.52,6.13-14.55,1.24-19.1-.44a16.56,16.56,0,0,1-7-4.82l2.09,4a12.46,12.46,0,0,1-10.42-5.54c-4.35-6,4.92-16.5,5.56-18.59s.08-16.78,15.67-16C254.06,129.74,260.36,128.58,264.82,132.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68,167.34a13.93,13.93,0,0,0,3.55-4.71,8.87,8.87,0,0,0,.3-5.84,19.69,19.69,0,0,0-3.62-6.12c-1.49-1.95-3.12-3.8-4.57-5.77-.08-.11.08-.23.17-.14a54.06,54.06,0,0,1,4.38,4.57,25.88,25.88,0,0,1,3.6,4.79,9.65,9.65,0,0,1,1.32,5.27,9.38,9.38,0,0,1-1.45,4.25,20,20,0,0,1-3.59,3.82C276.69,167.53,276.6,167.42,276.68,167.34Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.77,157.87c1.21-5.57,5.64-9.52,8-14.53,1.29-2.71,2.19-5.65,4-8.08,0-.07.17,0,.12.08-1.47,2.17-2.17,4.66-3.14,7.07a38.54,38.54,0,0,1-3.82,6.84c-2.61,4-5.74,8.71-4.46,13.72.59,2.31,2.28,4.75,4.78,5.2.09,0,.05.18,0,.15a7.55,7.55,0,0,1-4.69-3.73A9.65,9.65,0,0,1,230.77,157.87Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71,159.34a10,10,0,0,1,.67-6,14.18,14.18,0,0,1,3.9-4.58c1.77-1.49,3.65-2.94,4.63-5.09,0-.09.17,0,.13.07-1.54,3.55-5,5.53-7.19,8.61-2.46,3.53-1.93,8.2.45,11.63a16.2,16.2,0,0,0,5.75,5,0,0,0,0,1,0,.06C235.13,167.08,231.52,163.81,230.71,159.34Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.18,230.23l-.23-11.3s-7.61-2.43-7.51-12.22c0-4.51,4.33-28,9.41-35,4.77-6.53,12.43-4.94,17-2.67,9,4.44,25.45,24.2,41.71,50.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,213.69a32.91,32.91,0,0,0-6.54,1.62c-1.07.4-2.11.87-3.16,1.38-.51.25-1,.47-1.56.7a5.15,5.15,0,0,1-1.69.47s0,.11,0,.12a8.9,8.9,0,0,0,1.63-.07,8.73,8.73,0,0,0,1.55-.43c1.08-.4,2.15-.87,3.23-1.28,2.17-.82,4.35-1.65,6.57-2.25C273.17,213.92,273.14,213.67,273,213.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.51,216.41a34.67,34.67,0,0,0-5.48-.31,22.94,22.94,0,0,0-2.73.27c-.43.06-.87.14-1.3.23s-.94.27-1.42.35c-.05,0-.05.12,0,.12.45-.06.91,0,1.37,0l1.36-.07,2.74-.13c1.82-.11,3.64-.2,5.46-.22C278.61,216.62,278.6,216.42,278.51,216.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.16,167.07s9.27,52.14,10.7,65.2c1,9.42,3.28,43.09,2.36,53.78l52.91-18.41s-3.76-28.41-16.61-48.57c-13-20.34-28.67-39.64-34.48-44.63C276.06,165.86,271.16,167.07,271.16,167.07Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.73,241c1.87.68,3.76,1.41,5.58,2.23s3.4,1.53,5.13,2.21a38.33,38.33,0,0,0,5.2,1.66,23.14,23.14,0,0,0,5.5.56c.07,0,.1.11,0,.13-5.68,1.49-11.7-1.19-16.65-3.73-1.67-.86-3.32-1.8-4.94-2.77A.16.16,0,0,1,289.73,241Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.46,243.38a44,44,0,0,0,7.5,4.1,36.15,36.15,0,0,0,8.11,2.18c1.61.24,3.24.38,4.87.46a.08.08,0,0,1,0,.16,24.43,24.43,0,0,1-16.7-3.71,20.6,20.6,0,0,1-3.87-3.09A.06.06,0,0,1,290.46,243.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.39,246.39a111.83,111.83,0,0,0,4.13,11.72,10.47,10.47,0,0,0,2.37,3.4,13.39,13.39,0,0,0,7.49,2.77c2.41.2,5.28-.24,6.86-2.26,1-1.23.74-2.83.6-4.28a33.73,33.73,0,0,0-.9-5.3.06.06,0,0,1,.12,0c.47,1.56.92,3.12,1.25,4.72a8.79,8.79,0,0,1,.24,4.46c-.85,2.57-3.69,3.74-6.19,4a13.89,13.89,0,0,1-4.62-.47,15.32,15.32,0,0,1-4.06-1.62,11.3,11.3,0,0,1-3-3c-1.34-1.76-4-10.24-4.35-14.05C291.3,246.36,291.37,246.33,291.39,246.39Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,168.79c.16,1.14-2.09,10-7.26,11.28-2.68.65-4.64-7.77-4.64-7.77l-.38-.58-5.39-8,7.75-10.65,1.15-1.46s1.33,2.3,3,5.17c.08.13.15.26.23.41l.28.46c.24.43.5.86.74,1.3s.37.66.55,1l.56,1.05A64,64,0,0,1,270.8,168.79Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,156.76a19.37,19.37,0,0,1-6.46,15l-5.39-8,7.75-10.65,1.15-1.46S263.36,153.89,265,156.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.64,145.61c-5.17,16.16,3.92,21.08,7.41,22.19,3.16,1,14.06,4,20.88-11.5s.93-23.05-6.19-25.74S242.81,129.45,237.64,145.61Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,145.65c.37-.13.74-.19,1.13-.29a1.87,1.87,0,0,1,1.21-.08.6.6,0,0,1,.33.66,1.49,1.49,0,0,1-1.16,1,2.18,2.18,0,0,1-1.59-.08A.65.65,0,0,1,240,145.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.1,147.49a11.44,11.44,0,0,0-1-.57,1.84,1.84,0,0,0-1.16-.38.6.6,0,0,0-.48.55,1.47,1.47,0,0,0,.88,1.23,2.18,2.18,0,0,0,1.55.33A.65.65,0,0,0,252.1,147.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.92,149.82s.08.08.07.12c-.31,1.11-.48,2.44.44,3.06,0,0,0,.08,0,.06C248.21,152.59,248.45,150.83,248.92,149.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21,148.89c1.84.31,1.1,4-.61,3.68S248.67,148.64,250.21,148.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,149.23c.28.27.52.7.89.82s.85-.18,1.22-.49c0,0,.06,0,.05.05-.13.71-.54,1.37-1.32,1.32s-1.07-.76-1.1-1.5C250.63,149.29,250.78,149.12,250.89,149.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.35,148.63s-.1,0-.11.08c-.17,1.14-.57,2.42-1.67,2.61,0,0,0,.06,0,.06C241.86,151.44,242.36,149.74,242.35,148.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.55,147.25c-1.8-.48-2.62,3.16-1,3.6S243.06,147.65,241.55,147.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8,147.28c-.37.14-.76.43-1.15.38s-.7-.51-.91-.95c0,0-.06,0-.07,0a1.36,1.36,0,0,0,.66,1.75c.66.24,1.29-.26,1.62-.92C241,147.45,240.94,147.23,240.8,147.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.28,159.29c-.29.25-.58.61-1,.63a3.11,3.11,0,0,1-1.23-.35s-.07,0-.05.06a1.55,1.55,0,0,0,1.43.69,1.22,1.22,0,0,0,1-1C248.41,159.28,248.32,159.25,248.28,159.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.48,153.93s-.42,1.71-.5,2.53c0,.08.18.14.46.18h0a3.93,3.93,0,0,0,3.93-1.07.09.09,0,0,0-.11-.13,5.91,5.91,0,0,1-3.66.66c0-.23.81-2.91.69-2.93a7,7,0,0,0-1.91.23c.77-3.59,2.1-7,2.81-10.61,0-.13-.16-.19-.21-.08A60.27,60.27,0,0,0,241.5,154C241.39,154.48,243.14,154,243.48,153.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.39,142a12.91,12.91,0,0,1-1.86-.21c-.62-.13-1.21-.39-1.83-.52a10.48,10.48,0,0,0-3.57.1c-.1,0-.1.08,0,.07a8.86,8.86,0,0,1,3.73.18,11.35,11.35,0,0,0,3,.62,11.12,11.12,0,0,1,6.63,2s0,0,0,0A11.2,11.2,0,0,0,247.39,142Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247.73,140.39a11.55,11.55,0,0,1-1.76-.19c-.59-.14-1.14-.38-1.73-.5a9.69,9.69,0,0,0-3.39.1c-.1,0-.09.07,0,.06a8.45,8.45,0,0,1,3.54.17,10.48,10.48,0,0,0,2.87.59,10.65,10.65,0,0,1,6.28,1.86s0,0,0,0A10.59,10.59,0,0,0,247.73,140.39Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,154.07a4.72,4.72,0,0,0,0,2.39,6.93,6.93,0,0,0,1,2.21,8.88,8.88,0,0,0,1.58,1.82l.94.74c.34.21.67.43,1,.62-.59-.54-1.17-1.06-1.71-1.62a13.15,13.15,0,0,1-1.44-1.81,8.79,8.79,0,0,1-1-2.06A6.26,6.26,0,0,1,247.48,154.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.44,154a18.66,18.66,0,0,1-1.38,2.84,7.93,7.93,0,0,1-.94,1.22,6.65,6.65,0,0,1-1.24,1,3.57,3.57,0,0,0,1.48-.71,5,5,0,0,0,1.09-1.24,6.49,6.49,0,0,0,.69-1.49A6.2,6.2,0,0,0,243.44,154Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.68,156.92c-3.12-.42-2.05-7.54-2.05-7.54s-12.28-5.61-10.58-16.37a18.3,18.3,0,0,1-11.52,7.31s3.5-11.35,13.2-11.16c0,0,12.38-1.1,16.35,9.55S265.77,157.2,263.68,156.92Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21,132.23a11.75,11.75,0,0,0-.7,4.93,12.22,12.22,0,0,0,1.3,4.87,9.27,9.27,0,0,0,.64,1.1l.33.54.39.5c.27.33.53.66.81,1l.92.86c.16.14.31.29.47.42l.51.37,1,.74c.72.42,1.46.81,2.2,1.18-.66-.52-1.35-1-2-1.48l-.93-.8-.46-.4c-.15-.14-.28-.3-.42-.45-.27-.3-.54-.6-.83-.88s-.48-.65-.73-1l-.36-.48-.31-.52a10.68,10.68,0,0,1-.59-1,14.36,14.36,0,0,1-1.4-4.6,15.11,15.11,0,0,1-.12-2.43A14.42,14.42,0,0,1,251.21,132.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.24,154.15s4.78-4.35,6.83-2.53-2.36,8.69-5.34,9.09a2.86,2.86,0,0,1-3.41-2.35Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.76,153.56a0,0,0,0,1,0,.08c-2.11.34-3.53,1.9-4.66,3.59a1.58,1.58,0,0,1,2.4.11s0,.11-.07.09a1.76,1.76,0,0,0-2,.17,8.75,8.75,0,0,0-1.26,1.32c-.13.16-.42,0-.31-.19l0,0C261.37,156.22,264.06,153.21,266.76,153.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.64,160.31a1.34,1.34,0,1,1-1.08-1.56A1.35,1.35,0,0,1,263.64,160.31Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.71,172l4.09,6.67,7.55-11.62,3.34,2.35s-6.79,17.25-7,16.59l-4-5.91-3.54,4.75-1.24-10.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.81,174.65c0-.07.1-.13.12-.05.6,2,1.41,9.93,1.42,9.92.13-.24,3.26-4.46,3.31-4.41a65.1,65.1,0,0,1,4.1,5.43c.84-2.7,5.49-12.63,6.61-15.27,0-.08.15-.05.13,0-.64,2.8-6.46,16.31-6.58,16.3s-3.71-5.13-4.31-6.12c-.46,1-3.53,5.24-3.61,5C258.45,183.64,258.05,176.52,257.81,174.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.3,463.92h7.23V264a11.27,11.27,0,1,1,22.53,0v12.09h7.22V264a18.49,18.49,0,0,0-37,0Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.3,463.92h7.23V264a11.27,11.27,0,1,1,22.53,0v12.09h7.22V264a18.49,18.49,0,0,0-37,0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.87 463.92 218.97 463.92 218.15 452.72 209.79 452.72 208.87 463.92",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.19,177.83c4.36,17.59,7,50.54,4.29,56.41-2.42,5.2-23.44,14.18-33.08,17.38-3.61,1.2-11.45-27.08-7.56-28.28,4.66-1.45,18.27-6.2,18.73-7.4s3.24-23.55,6.34-37.59C274.71,165.61,281.54,171.17,283.19,177.83Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,226.29c-8.31,3.16-9.95,5.24-18.38,4.19-5.53-.7-8.35,2.54-3.59,5.85,7.78,5.42,19.35,3.6,23.19,1.81Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.56,222.47s-11.31-.06-20.5,2.43c-6.35,1.72-19.76,7-25,26-1.24,4.5.19,11.78,4.87,5.17,3.33-4.7,4-8.68,6.45-11,0,0,2.92,9,7.47,10.1A86.8,86.8,0,0,0,244,257a19,19,0,0,0,.56-2.23s4.34.59,9.86-3.16Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.26,227.51c-1.92,2.87-5.87,9-7.36,15.18-1.65,6.84-3,20.46,2.08,21.63,3.71.85,4.68-4.3,4.68-4.3s.63,5.74,4.15,5.78c3.21,0,3.72-4,3.72-4s1,3.42,4.08,2.86c3.73-.68,1-7.73,4.24-11.68C248.56,252.11,232.26,227.51,232.26,227.51Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,243.23a28,28,0,0,0-.87,16.69c0,.14.17.18.16.05a68.46,68.46,0,0,1,.78-16.72A0,0,0,0,0,232.42,243.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.28,245.1c-.91,2.7-1.94,10.59.12,16.71,0,.14.18.17.16,0a74.2,74.2,0,0,1-.22-16.74S239.29,245.06,239.28,245.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.51,226.89c-4.09,1.83-8.28,4-12.86,4.09-2.88-.08-6.08-.87-8.79.22-3,2,1.29,5.3,3.24,6.29a15.73,15.73,0,0,0,4.16,1.63,15.93,15.93,0,0,1-4.28-1.41c-2.3-1-6.74-4.63-3.34-6.91,2.86-1.22,6.06-.39,9-.27,4.46-.06,8.69-2.08,12.83-3.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.53,236a45.84,45.84,0,0,0-7,14.23,15.15,15.15,0,0,0-.57,5.16c.41,3.7,2.51,3.65,4.42.84,2.39-3.73,3.86-8,6.75-11.48l.79-1c-.91,5.3-1.82,10.78-1,16.15.31,1.58.83,3.4,2.39,4.15a3.55,3.55,0,0,1-1.79-1.71c-2.3-5.35-1.2-11.84-.45-17.46l.58.27a51.51,51.51,0,0,0-5.27,9.17,10.75,10.75,0,0,1-3.38,4.29c-2.28,1.37-3.6-1.24-3.69-3.17-.15-7.17,4-13.9,8.19-19.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,254.79l-11.55-32.53,17.3-6.87c1.75-10.84,5.26-32.52,7.6-39.83,2.74-8.58,8.88-7.24,11.41,1.58,5.79,20.18,7.24,54.16,5,58.9C285.45,242.84,258.9,254.79,258.9,254.79Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.77,248.89c-.33-2.14-3.17-10.61-3.9-12.72s-4-10.43-4.7-12.59c0-.12-.23-.09-.19,0,.72,2.14,3.28,10.74,4,12.85s3.65,10.53,4.69,12.46C262.7,249,262.79,249,262.77,248.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.07,249.31a120.63,120.63,0,0,0,15.1-9.88,13.56,13.56,0,0,0,3-3.17c1.54-4.12,1-8.88,1-13.24-.55-12-1.95-24-3.2-36,1.11,5.93,2,11.91,2.7,17.9s1.28,12,1.43,18.06c0,4.53.46,9.28-1.37,13.58-2.76,3.73-7,5.88-10.77,8.33q-3.89,2.32-7.9,4.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,192.14a29.82,29.82,0,0,1,.13-3.41,7.43,7.43,0,0,1-.13,3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.79,192.17c-1.22,7.52-1.89,15.42-3.59,22.85-.08.26-.18.61-.46.74-5.67,2.58-11.51,4.5-17.38,6.54l0-.05.25.83-.32-.81,0,0c3.26-1.37,6.54-2.69,9.81-4,1.64-.73,5.91-2.26,7.3-3.12,1.81-7.55,2.51-15.37,4.38-22.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.83,193.09a27.66,27.66,0,0,1,.27,3.41,7.44,7.44,0,0,1-.27-3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.97,
    y: 288.13,
    width: 88.48,
    height: 34.11,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,404.29H294V400h74a12.15,12.15,0,0,0,12.14-12.14V212.33a16.44,16.44,0,0,1,16.42-16.42h10v4.28h-10a12.15,12.15,0,0,0-12.14,12.14V387.87A16.44,16.44,0,0,1,368,404.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.11,448.49h-4.27V267.36a14.8,14.8,0,0,1,14.78-14.78h75.66v4.27H306.62a10.52,10.52,0,0,0-10.51,10.51Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.3,
    y: 193.65,
    width: 26.48,
    height: 8.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.59,461.8c-33,0-59.78-33.47-59.78-74.62s26.82-74.62,59.78-74.62,59.79,33.48,59.79,74.62S408.56,461.8,375.59,461.8Zm0-143.26c-29.66,0-53.8,30.79-53.8,68.64s24.14,68.64,53.8,68.64S429.4,425,429.4,387.18,405.26,318.54,375.59,318.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,453.33c-29.16,0-52.89-29.67-52.89-66.15S351.15,321,380.31,321s52.9,29.68,52.9,66.15S409.48,453.33,380.31,453.33Zm0-128c-26.81,0-48.62,27.75-48.62,61.87s21.81,61.88,48.62,61.88,48.62-27.76,48.62-61.88S407.12,325.31,380.31,325.31Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 378.29,
    cy: 387.18,
    rx: 8.58,
    ry: 10.81,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.04,
    cy: 387.18,
    rx: 8.58,
    ry: 10.81,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.04,
    cy: 449.78,
    rx: 11.16,
    ry: 14.07,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.62,
    cy: 449.78,
    rx: 11.16,
    ry: 14.07,
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.27,112.25a21,21,0,0,0,33.55,16.88l10.3,2.63-4.29-9.59a20.79,20.79,0,0,0,2.49-9.92,21,21,0,0,0-42,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.27,112.25c.08,17.09,19.68,26.93,33.34,16.6l.13-.1.17,0,10.32,2.55-.51.6-4.33-9.57-.09-.22.11-.21c6.32-11.57-.27-26.6-13.07-29.8-13-3.57-26.13,6.68-26.07,20.11Zm0,0c0-17.88,21-27.75,34.8-16.36,7.68,6.19,10.05,17.87,5.19,26.51V122l4.25,9.61.37.84-.88-.23-10.28-2.71.3-.06a21.29,21.29,0,0,1-10.91,4c-12.05,1.06-23-9.07-22.85-21.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.27,117a34.22,34.22,0,0,0,11,9.5,34.14,34.14,0,0,0,11-9.5c3.85-5.11,3.66-13.1-1.85-14.83-6.1-1.91-9.1,7.27-9.1,7.27s-3-9.24-9.11-7.27C201.63,103.92,201.42,111.85,205.27,117Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.53 122.43 222.19 115.5 223.28 117.94 230 117.94 230 117.16 223.79 117.16 221.97 113.08 220.68 118.48 218.84 107.29 217.22 116.14 215.95 112.45 213.93 118.5 213.48 117.16 202.45 117.16 202.45 117.94 212.92 117.94 213.93 120.96 215.96 114.88 217.46 119.21 218.8 111.87 220.53 122.43",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCareCuate);
export default __webpack_public_path__ + "static/media/Medical-care-cuate.3976f6260e1e2040271ed01edd822de1.svg";
export { ForwardRef as ReactComponent };